import { Injectable } from "@angular/core";
import { UserEventsService } from "@services";
import { PagedFilter, Pages, RaceRegistration, UserStatistics, UserRegistrationFilter, EventItem, FindEventsRequest, UserEvent } from "@model";
import { BehaviorSubject, Observable } from "rxjs";
import { DataStore } from "./data-store.base";

@Injectable({ providedIn: 'root' })
export class MyTraceyDataStore extends DataStore {

    protected store = {
        upcoming: new BehaviorSubject<UserEvent[]>([]),
        results: new BehaviorSubject<UserEvent[]>([]),
        allFavorites: new BehaviorSubject<EventItem[]>([]),
        favorites: new BehaviorSubject<EventItem[]>([]),
        registrations: new BehaviorSubject<RaceRegistration[]>([]),
        recommended: new BehaviorSubject<EventItem[]>([]),
        userStatistics: new BehaviorSubject<UserStatistics | undefined>(undefined)
    };

    readonly upcoming$ = this.select<UserEvent[]>('upcoming');
    readonly results$ = this.select<UserEvent[]>('results');
    readonly allFavorites$ = this.select<EventItem[]>('allFavorites');
    readonly favorites$ = this.select<EventItem[]>('favorites');
    readonly registrations$ = this.select<RaceRegistration[]>('registrations');
    readonly recommended$ = this.select<EventItem[]>('recommended');
    readonly userStatistics$ = this.select<UserStatistics>('userStatistics');

    constructor(private userEventsService: UserEventsService) {
        super();
    }

    initUpcoming() {
        return this.init('upcoming', () => this.userEventsService.fetchUserUpcomingEvents(FindEventsRequest.createEventPageFilter(1)));
    }

    initResults() {
        return this.init('results', () => this.userEventsService.fetchUserPastEvents(FindEventsRequest.createEventPageFilter(1)));
    }

    initAllFavorites() {
        return this.init('allFavorites', () => this.userEventsService.fetchAllUserFavoriteEvents());
    }

    initFavorites() {
        return this.init('favorites', () => this.userEventsService.filterUserFavoriteEvents(FindEventsRequest.createEventPageFilter(1)));
    }

    initRecommended() {
        return this.init('recommended', () => this.userEventsService.fetchUserRecommendedEvents());
    }

    initUserStatistics() {
        return this.init('userStatistics', () => this.userEventsService.fetchStatistics(new Date().getFullYear()));
    }

    initRegistrations() {
        return this.init('registrations', () => this.userEventsService.fetchUserRegistrations(
            new PagedFilter(new Pages(undefined, 1), new UserRegistrationFilter())
        ));
    }

    preloadAll(): Observable<void> {
        return super.preload(
            this.initUpcoming(),
            this.initAllFavorites(),
            this.initFavorites(),
            this.initResults(),
            this.initRecommended(),
            this.initUserStatistics(),
            this.initRegistrations()
        );
    }
}